<template>
  <v-container>
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-form ref="form" v-model="valid" @submit.prevent="handleSubmit">
      <v-row>
        <v-col cols="12" md="6" lg="4">
          <v-text-field filled hide-details="" label="New Member name" v-model="memberName" :rules="requiredField" />
        </v-col>
        <v-col cols="12" md="12">
          <v-btn type="submit" color="primary" :disabled="!valid" rounded>Add Member </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <div class="display-2 text-center font-weight-medium my-10">Member List</div>
    <v-row>
      <v-col cols="12" md="6" lg="4" v-for="member in memberList" :key="member._id">
        <router-link class="text-decoration-none" :to="`/members/${member._id}`">
          <list-card :name="member.name" />
        </router-link>
      </v-col>
    </v-row>
    <app-snackbar />
  </v-container>
</template>

<script>
import AppSnackbar from "../components/common/AppSnackbar.vue";
import ListCard from "../components/common/ListCard.vue";
import { requiredField } from "../validations/FieldValidation";
import { mapState } from "vuex";

export default {
  components: { ListCard, AppSnackbar },
  data: () => ({
    memberName: "",
    valid: true,
    requiredField,
  }),
  computed: {
    ...mapState(["memberList", "isLoading"]),
  },
  created() {
    this.$store.dispatch("getMembers");
  },
  methods: {
    handleSubmit() {
      this.$store.dispatch("addNewMember", { name: this.memberName }).then(() => this.$refs.form.reset());
    },
  },
};
</script>

<style lang="scss" scoped></style>
